import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'

import './styles/tokens.css'
import { appConfig } from './config/env'
import { AuthProvider } from './auth/AuthProvider'
import { ConfigurationMissing } from './auth/ConfigurationMissing'
import { queryClient } from './query/client'
import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // Restore scroll position on route navigation.
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function App() {
  if (!appConfig.ok) {
    return <ConfigurationMissing missing={appConfig.missing} />
  }

  return (
    <AuthProvider config={appConfig.config}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </AuthProvider>
  )
}

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Missing #root element in index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
